// extracted by mini-css-extract-plugin
export default {"lds-dual-ring":"style_lds-dual-ring__bQ1dw","lds-dual-ring-after":"style_lds-dual-ring-after__cDBb0"};